import { useMount } from 'ahooks';
import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import ResponsiveImage from '../../parts/ResponsiveImage';
import ImageZoom from 'react-image-zooom';
import { getVariantFromURL, buildGalleryImages } from './utils';

const GalleryProvider = (props) => {
  const { data, isFetching } = useQuery(
    'product',
    async () => {
      return await fetch(`${window.location.origin}/${window.location.pathname}.json`).then((res) => res.json());
    },
    {
      refetchOnWindowFocus: false,
    }
  );

  if (!data || isFetching) {
    return null;
  }

  return <ProductGallery {...props} data={data} isFetching={isFetching} />;
};

const MainImage = ({ mainImage, product }) => {
  let firstSplit = mainImage.src.split('?v=');
  let baseName = firstSplit[0].slice(0, -4);
  let extension = firstSplit[0].slice(-4);
  return (
    <figure className="mainImage">
      <ImageZoom key={mainImage.id} src={`${baseName}_800x${extension}`} alt={mainImage.alt || product.title} zoom={200}></ImageZoom>
    </figure>
  );
};

const ProductGallery = ({ data, isFetching, defaultvariant }) => {
  const [mainImage, setMainImage] = useState(null);
  const [galleryImages, setGalleryImages] = useState([]);

  useMount(() => {
    window.theme_app.on('selectedVariant', (state) => {
      let galleryImages = buildGalleryImages({ images: data.product.images, variant: getVariantFromURL() || parseInt(defaultvariant) });
      setGalleryImages(galleryImages);
      setMainImage(galleryImages[0]);
    });
  });

  useEffect(() => {
    if (!isFetching && data.product?.images) {
      let galleryImages = buildGalleryImages({ images: data.product.images, variant: getVariantFromURL() || parseInt(defaultvariant) });
      setGalleryImages(galleryImages);
      setMainImage(galleryImages[0]);
    }
  }, [data, isFetching]);

  const handleImageClick = (image) => () => {
    setMainImage(image);
  };

  if (!galleryImages.length) {
    return null;
  }

  return (
    <>
      <MainImage mainImage={mainImage} product={data.product}></MainImage>
      <div className="thumbs">
        {galleryImages?.map((image, index) => {
          return (
            <figure key={image.id} onClick={handleImageClick(image)} className={classNames({ isActive: image.id === mainImage.id })}>
              <ResponsiveImage image={image.src} title={image.alt || data.product.title}></ResponsiveImage>
            </figure>
          );
        })}
      </div>
    </>
  );
};

export default GalleryProvider;
